import firebase from "firebase/compat/app"; // Assuming firebase is imported properly

export async function getAuthorProfileBasedOnUid(
  uid: string,
  platform: "WOG" | "LEGION" | string
) {
  // const userNameDoc = await cacheDatabase
  //   .ref("/userNames")
  //   .child(platform)
  //   .orderByChild("uid")
  //   .equalTo(uid)
  //   .get();

  // const userNameDoc = await firestore.doc
  //   .ref("/userNames")
  //   .child(platform)
  //   .orderByChild("uid")
  //   .equalTo(uid)
  //   .get();

  const userNameDoc = await firebase
    .firestore()
    .collection("profiles")
    .doc(platform)
    .collection("records")
    .doc(uid)
    .get();

  // const users: Response[] = [];
  // userNameDoc.forEach((val) => {
  //   const user = val.val() as Response;
  //   users.push(user);
  // });
  return userNameDoc.data();
}
